import { IonButton, IonButtons, IonContent, IonHeader, IonModal, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";
import "../../pages/Privacidad/Privacidad.css";

interface ModalPrivacidadProps {
  abrirModal: boolean;
  setAbrirModal: (value: boolean) => void;
}

const ModalPrivacidad: React.FC<ModalPrivacidadProps> = ({ abrirModal, setAbrirModal }) => {
  const [copiado, setCopiado] = useState(false);

  const copiarEmail = () => {
    navigator.clipboard.writeText("info@clinicaprivadasanjosesrl.com.ar");
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2000);
  };

  return (
    <IonModal isOpen={abrirModal} onDidDismiss={() => setAbrirModal(false)}>
      <IonHeader>
        <IonToolbar color="favorite">
          <IonTitle>Política de Privacidad</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={() => setAbrirModal(false)} strong>
              Cerrar
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className="privacidad-header">
          <h1 className="privacidad-title">Política de Privacidad</h1>
          <p className="privacidad-subtitle">Clínica San José</p>
        </div>

        <div className="privacidad-container">
          {/* <h1>Política de Privacidad</h1> */}
          <section className="privacidad-section">
            <h2>1. Introducción</h2>
            <p>
              En <strong>Clínica San José</strong> nos comprometemos a proteger la privacidad y seguridad de los
              datos personales de nuestros usuarios. Esta Política de Privacidad explica cómo recopilamos, utilizamos y protegemos su información.
            </p>

            <h2>2. Datos que recopilamos</h2>
            <p>Podemos recopilar información de forma directa a través de formularios u otros medios como:</p>
            <ul>
              <li>Datos de identificación (nombre, apellidos).</li>
              <li>Datos de contacto (correo electrónico, teléfono).</li>
              <li>Datos relacionados con consultas o solicitudes realizadas.</li>
            </ul>
            <p>
              Toda información médica o sensible solo será tratada en los casos en que el usuario la facilite voluntariamente y se requerirá
              consentimiento explícito.
            </p>

            <h2>3. Finalidad del tratamiento</h2>
            <p>Los datos personales se utilizan para:</p>
            <ul>
              <li>Gestionar citas, consultas y solicitudes realizadas por el usuario.</li>
              <li>Ofrecer información relacionada con nuestros servicios.</li>
              <li>Cumplir obligaciones legales de carácter sanitario o administrativo.</li>
              <li>Mejorar la calidad de nuestros servicios.</li>
            </ul>

            <h2>4. Base legal</h2>
            <p>La base legal para el tratamiento de los datos puede ser:</p>
            <ul>
              <li>El consentimiento del usuario.</li>
              <li>La ejecución de una relación contractual o precontractual.</li>
              <li>El cumplimiento de obligaciones legales aplicables.</li>
            </ul>

            <h2>5. Cesión de datos</h2>
            <p>
              Los datos no se cederán a terceros salvo obligación legal o cuando sea necesario para la prestación del servicio (por ejemplo,
              proveedores sanitarios o administrativos).
            </p>

            <h2>6. Conservación de datos</h2>
            <p>
              Los datos se conservarán durante el tiempo necesario para cumplir con las finalidades para las que fueron recabados y durante los plazos
              legalmente exigidos.
            </p>

            <h2>7. Derechos del usuario</h2>
            <p>El usuario puede ejercer sus derechos de:</p>
            <ul>
              <li>Acceso</li>
              <li>Rectificación</li>
              <li>Supresión</li>
              <li>Oposición</li>
              <li>Limitación del tratamiento</li>
              <li>Portabilidad</li>
            </ul>
            <p>Para ejercer estos derechos puede contactarnos e</p>

            <h2>8. Seguridad de los datos</h2>
            <p>
              Implementamos medidas técnicas y organizativas apropiadas para garantizar la seguridad de los datos personales y evitar accesos no
              autorizados o tratamientos indebidos.
            </p>

            <h2>9. Actualizaciones</h2>
            <p>
              Nos reservamos el derecho a modificar esta Política de Privacidad en cualquier momento. Cualquier cambio será comunicado mediante su
              publicación en esta página.
            </p>

            <h2>10. Contacto</h2>
            <p>
              Para consultas relacionadas con esta política, puede comunicarse con nosotros al correo electrónico:{" "}
              <span className="email-link" onClick={copiarEmail} title="Clic para copiar">
                info@clinicaprivadasanjosesrl.com.ar
              </span>
              {copiado && <span className="copiado-mensaje"> ✓ Copiado</span>}
            </p>
          </section>
        </div>
        <footer className="privacidad-footer">© 2025 Clínica San José de
Otorrinolaringología  — Todos los derechos reservados.</footer>
      </IonContent>
    </IonModal>
  );
};

export default ModalPrivacidad;
